import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { XmlCursorPos } from '../../code/cursor/xmlCursorPos.class';
import { XmlEditRuleCheckAttributes } from '../../code/xml-rules-check/xmlEditRuleCheckAttributes.class';
import { XmlRuleAttribut, RuleAttributeTypes } from '../../code/xml-rules-check/xmlRuleAttribut.class';
import { AngularXmlEditorService } from '../../angular-xml-editor.service';
import { Subscription } from 'rxjs';
import { XmlEditorContext } from '../../code/xmlEditorContext.class';
import { Xml2htmlAttributeWorker } from '../../code/xml-html-converter/xml2htmlAttributeWorker.class';
import { Xml2html } from '../../code/xml-html-converter/xml2html.class';

@Component({
  selector: 'axed-attribute-editor',
  templateUrl: './xml-editor-attribute-editor.component.html',
  styleUrls: ['./xml-editor-attribute-editor.component.scss']
})
export class XmlEditorAttributeEditorComponent implements OnInit, OnDestroy {
  private editorContext: XmlEditorContext;

  @Input('editorContextId')
  set editorContextId(value: string) {
    if (!value) {
      return;
    }
    this.editorContext = this.editorService.getEditorContext(value);
    this.actualCursorPosChangedSubscription = this.editorContext.actualCursorChanged.subscribe(pos => {
      this.attributes = this.GetAttributesForCursorPos(pos.StartPos);
      this.elementName = this.GetElementNameForCursorPos(pos.StartPos);
    });
  }

  actualCursorPosChangedSubscription: Subscription;

  attribTypes = RuleAttributeTypes;

  attributes: ToolbarAttributData[] = [];
  elementName: string;
  actualElement: Element;

  constructor(private editorService: AngularXmlEditorService) {}

  ngOnInit() {}

  ngOnDestroy(): void {
    this.actualCursorPosChangedSubscription.unsubscribe();
  }

  attributeValueChanged(key: string, value: string) {
    if (this.actualElement) {
      const attribWorker = new Xml2htmlAttributeWorker(this.editorContext.config.rules);
      attribWorker.writeAttributeToHtml(this.actualElement, key, value);
    }
  }

  GetElementNameForCursorPos(pos: XmlCursorPos): string {
    const rulesCheck = new XmlEditRuleCheckAttributes(this.editorContext.config.xmlSchema);
    const parentNode = rulesCheck.getRelevantParentNodeForCursorPos(pos) as Element;
    if (parentNode) {
      return Xml2html.getTagNameFromNode(parentNode);
    }
    return undefined;
  }

  GetAttributesForCursorPos(pos: XmlCursorPos): ToolbarAttributData[] {
    const attribWorker = new Xml2htmlAttributeWorker(this.editorContext.config.rules);
    const rulesCheck = new XmlEditRuleCheckAttributes(this.editorContext.config.xmlSchema);
    const parentNode = rulesCheck.getRelevantParentNodeForCursorPos(pos) as Element;
    this.actualElement = parentNode;
    if (parentNode) {
      const allowedAttributes = rulesCheck.AttributesAllowedAtThisCursorPos(pos);
      return allowedAttributes.map(a => {
        return {
          rules: a,
          value: attribWorker.getAttributeValueFromHtml(parentNode, a.attribName)
        } as ToolbarAttributData;
      });
    }
    return [];
  }
}

export interface ToolbarAttributData {
  rules: XmlRuleAttribut;
  value: string;
}
